import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Icon } from "@/DesignSystem";

import styles from "./SearchInput.module.scss";

import MagnifyingGlass from "@/DesignSystem/Atoms/Icons/Types/MagnifyingGlass/magnifying-glass-regular.svg";

function SearchInput(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={`${styles.searchInput}`}>
            <Icon size="md">
                <MagnifyingGlass />
            </Icon>
            <input
                {...props}
                className={`form-control ${props.className}`}
                placeholder={getText("SearchLabel")}
            />
        </div>
    );
}

export { SearchInput };
